import { useMemo } from 'react';
import { useUser } from '../contexts/UserContext';
import { readAccessFlagsFromUser } from '../utils/userAccessFlags';

export function useUserAccessFlags() {
  const { userData } = useUser();
  return useMemo(() => readAccessFlagsFromUser(userData), [userData]);
}
